import { Controller } from '@hotwired/stimulus';

// 書面一括エクスポートの進捗を定期ポーリングし、状態・進捗・停滞判定に変化があれば
// ページを再読み込みする。完了状態で表示された場合はポーリングしない。
export default class extends Controller {
  static values = {
    url: String,
    state: String,
    completedCount: Number,
    stalled: Boolean,
    interval: { type: Number, default: 5000 },
  };

  connect() {
    if (this.stateValue === 'completed') return;

    this.timer = setInterval(() => this.refresh(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;

      const data = await response.json();
      const changed = data.state !== this.stateValue
        || data.completed_count !== this.completedCountValue
        || data.stalled !== this.stalledValue;
      if (changed) window.location.reload();
    } catch {
      // 一時的な通信エラーは無視して次回のポーリングに任せる
    }
  }
}
